import React from 'react'
import './AuthPages.css'

const AuthLoadingPage: React.FC = () => {
  return (
    <div className="auth-page auth-page--loading">
      <div className="auth-page__bg" />
      <div className="auth-loading">
        <div className="auth-loading__spinner" />
        <p className="auth-loading__text">Loading...</p>
      </div>
    </div>
  )
}

export default AuthLoadingPage
